import { baseUrl } from './api.js';

/**
 * Krok QAFIX9 (nalez QA-ZAV-N1) — TARIF A PLATBA UVNITR APLIKACE.
 *
 * Stejny vzor jako `offices-api.ts`/`ai-credits-api.ts`: raw `fetch`, protoze
 * routy jsou nove a jeste nejsou v generovanem `@reos/api-client` schematu.
 *
 * ZADNA CENA SE TU NEPOCITA. Server posila hotove castky z CENIKU
 * (`officePlanOffersOf` v @reos/commerce) vcetne zakladu DPH, ceny s DPH
 * i ceny dalsich makleru nad limit - obrazovka je jen vykresluje.
 */

export interface OfficePlanOffer {
  readonly productCode: string;
  readonly nameKey: string;
  readonly billingPeriod: 'ONE_OFF' | 'MONTHLY' | 'YEARLY' | null;
  readonly priceNet: string;
  readonly vatRate: string;
  readonly priceGross: string;
  readonly currency: string;
  readonly includedUsers: number | null;
  readonly extraUsers: number;
  readonly extraUserPriceNet: string | null;
  readonly extraUserPriceGross: string | null;
  readonly extraUsersMonthlyNet: string;
  readonly extraUsersMonthlyGross: string;
  readonly current: boolean;
}

export interface OfficePlanOffers {
  readonly items: readonly OfficePlanOffer[];
  readonly currentPlanCode: string | null;
  readonly activeUsers: number;
  readonly vatPayer: boolean;
}

export interface OfficePlanBilling {
  readonly name: string;
  readonly company?: string;
  readonly ico?: string;
  readonly vatId?: string;
  readonly street?: string;
  readonly city?: string;
  readonly zip?: string;
  readonly country?: string;
}

export interface OfficePlanCheckout {
  readonly publicToken: string;
  readonly orderNumber: string;
  readonly redirectUrl: string;
}

interface ProblemBody {
  readonly detail?: string;
  readonly title?: string;
}

async function parse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    let detail = '';
    try {
      const body = (await res.json()) as ProblemBody;
      detail = body.detail ?? body.title ?? '';
    } catch {
      detail = '';
    }
    throw new Error(detail === '' ? `HTTP ${String(res.status)}` : detail);
  }
  return (await res.json()) as T;
}

export async function getOfficePlanOffers(): Promise<OfficePlanOffers> {
  const res = await fetch(`${baseUrl}/v1/office-plan/offers`, { credentials: 'include' });
  return parse<OfficePlanOffers>(res);
}

/**
 * Zalozi objednavku tarifu a vrati odkaz na platebni stranku. KANCELAR SE
 * NEPOSILA - tenant bere server z prihlasene session (`ctx`), aby nebylo cim
 * objednat tarif cizi kancelari.
 */
export async function createOfficePlanCheckout(input: {
  readonly productCode: string;
  readonly email: string;
  readonly billing: OfficePlanBilling;
}): Promise<OfficePlanCheckout> {
  const res = await fetch(`${baseUrl}/v1/office-plan/checkout`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
  return parse<OfficePlanCheckout>(res);
}
